import client from "./axiosConfig";

export const createProject = (values) => {
  const config = {
    url: "/projects/",
    method: "POST",
    data: values,
  };
  const response = client(config);
  return response;
};

export const getProjectDetails = (id) => {
  const config = {
    url: `/projects/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getSubmilestones = (project_id, milestone_id) => {
  const config = {
    url: `/projects/${project_id}/milestones/${milestone_id}/submilestones/`,
    method: "GET",
  };
  const response = client(config);
  return response;
}

export const getPaymentTimeline = (projectID) => {
  const config = {
    url: `/projects/${projectID}/payments/`,
    method: "GET",
  };
  const response = client(config);
  return response;
}

export const getPaymentDetailsById = (projectID, paymentID) => {
  const config = {
    url: `/projects/${projectID}/payments/${paymentID}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
}

export const updatePaymentById = (projectID, paymentID, data) => {
  const config = {
    url: `/projects/${projectID}/payments/${paymentID}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
}

export const addProjectPayment = (projectID, data) =>
{
  const config = {
    url: `/projects/${projectID}/payments/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
}

export const getProjectMilestones = (projectID) => {
  const config = {
    url: `/projects/${projectID}/milestones/`,
    method: "GET",
  };
  const response = client(config);
  return response;
}

export const updateProject = (projectID,data) => {
  const config = {
    url: `/projects/${projectID}/`,
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
}


export const uploadExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file); 

  const config = {
    url: `/projects/import-excel/`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return client(config);
};

export const previewExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file); 

  const config = {
    url: `/projects/preview/`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return client(config);
}


export const getProjects = (params) => {
    const config = {
        url: "/projects/",
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const updateMilestoneStatus = (project_id, milestones_id, data) => {
    const config = {
        url: `/projects/${project_id}/milestones/${milestones_id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
}

export const updateProjectStatus = (project_id,data) =>
{
  const config = {
    url: `/projects/${project_id}/`,
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
}

export const updateSubMilestoneStatus = (project_id, milestones_id, subMilestone_id, data) => {
    const config = {
        url: `/projects/${project_id}/milestones/${milestones_id}/submilestones/${subMilestone_id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
}

export const uploadMilestoneFile = (project_id, data) => {

    const config = {
        url: `/projects/${project_id}/files/`,
        method: "POST",
        data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };

    return client(config);
}

export const getFiles = (project_id, params) => {
    const config = {
        url: `/projects/${project_id}/files/`,
        method: "GET",
        params
    };

    return client(config);
}

export const getContact = (project_id, params) => {
  const config = {
    url: `/projects/${project_id}/contact/`,
    method: "GET",
    params
  }

  const response = client(config);
  return response;
}

export const addContact = (project_id, data) => {
  const config = {
    url: `/projects/${project_id}/contact/`,
    method: "POST",
    data
  }

  const response = client(config);
  return response;
}

export const deleteContact = (project_id, contact_id) => {
  const config = {
    url: `/projects/${project_id}/contact/${contact_id}/`,
    method: "DELETE",
  }

  const response = client(config);
  return response;
}

export const deleteFile = (project_id, file_id) => {
  const config = {
    url: `/projects/${project_id}/files/${file_id}/`,
    method: "DELETE",
  };

  return client(config);
};

export const getProjectPaymentFiles = (id,params) => {
  const config = {
    url: `/projects/${id}/project-payment-files/`,
    method: "GET",
    params
  };

  return client(config);
}

export const addProjectPaymentFile = (id,data) => {
  const config = {
    url: `/projects/${id}/project-payment-files/`,
    method: "POST",
    data
  }

  return client(config);
}

export const deletePaymentFile = (pid,fid) =>
{
  const config = {
    url: `/projects/${pid}/project-payment-files/${fid}/`,
    method : "DELETE"
  }

  return client(config);
}

export const addProjectDocuments = (project_id, data) => {
  const config = {
    url: `/projects/${project_id}/project-documents/`,
    method: "POST",
    data
  }

  return client(config);
}

export const getProjectDocuments = (project_id, params) => {
  const config = {
    url: `/projects/${project_id}/project-documents/`,
    method: "GET",
    params
  }

  return client(config);
}

export const deleteProjectDocuments = (project_id, file_id) => {
  const config = {
    url: `/projects/${project_id}/project-documents/${file_id}/`,
    method: "DELETE"
  }

  return client(config);
}

export const downloadProjectDocuments = async (projectId, filters) => {
  // Build query string dynamically
  const params = new URLSearchParams(filters).toString();
  const url = `/projects/${projectId}/project-documents/download-all/${
    params ? `?${params}` : ""
  }`;

  const response = await client.get(url, { responseType: "blob" });

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", `project_${projectId}_documents.zip`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getProjectSampleFiles = (params) => {
  const config = {
    url: `/projects/sample-files/`,
    method: "GET",
    params
  }

  return client(config);
}

export const deleteProjectSampleFile = (fileId) => {
  const config = {
    url: `/projects/sample-files/${fileId}/`,
    method:"DELETE"
  }

  return client(config);
}